<template>
  <div class="p-6 bg-white shadow rounded-lg">
    <div class="flex flex-wrap gap-4 mb-4 justify-end">
      <el-date-picker
        v-model="start_date"
        type="datetime"
        :picker-options="pickerOptions"
        format="yyyy-MM-dd"
        size="small"
        class="p-2 border rounded-md shadow-sm"
        placeholder="Эхлэх огноог сонгоно уу"
      />
      <el-date-picker
        v-model="end_date"
        :picker-options="pickerOptions"
        type="datetime"
        format="yyyy-MM-dd"
        size="small"
        class="p-2 border rounded-md shadow-sm"
        placeholder="Дуусах огноог сонгоно уу"
      />
      <el-button size="small" type="info" @click="getDashboardData" class="bg-blue-500 text-white px-4 py-2 rounded-md shadow-md hover:bg-blue-600">
        Хайх
      </el-button>
    </div>

    <div class="flex flex-wrap gap-8 justify-center">
      <div class="w-full md:w-2/5">
        <el-card class="p-4 shadow rounded-lg">
          <b class="text-lg font-semibold">Created Status</b>
          <apexchart
            type="donut"
            :options="chartCreated"
            :series="seriesCreated"
          ></apexchart>
        </el-card>
        <el-button
          class="w-full bg-green-500 text-white py-2 rounded-md shadow-md hover:bg-green-600"
          size="mini"
          type="success"
          icon="el-icon-download"
          @click="excelDownload('created')"
          :loading="excelLoading"
        >Татаж авах</el-button>
      </div>

      <div class="w-full md:w-2/5">
        <el-card class="p-4 shadow rounded-lg">
          <b class="text-lg font-semibold">Usage Status</b>
          <apexchart
            type="donut"
            :options="chartUsage"
            :series="seriesUsage"
          ></apexchart>
        </el-card>
        <el-button
          class="w-full bg-green-500 text-white py-2 rounded-md shadow-md hover:bg-green-600"
          size="mini"
          type="success"
          icon="el-icon-download"
          @click="excelDownload('usage')"
          :loading="excelLoading"
        >Татаж авах</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import XLSX from 'xlsx'
export default {
  created () {
    this.getDashboardData()
  },
  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      loading: false,
      start_date: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
      end_date: dayjs().format('YYYY-MM-DD'),
      tableData: [],
      createdData: [],
      usageData: [],
      excelLoading: false,
      chartUsage: [],
      seriesUsage: [],
      chartCreated: [],
      seriesCreated: []
    }
  },
  methods: {
    async getDashboardData () {
      this.loading = true
      const payload = {
        start_date: this.start_date,
        end_date: this.end_date
      }
      this.chartUsage = {
        chart: {
          width: 380,
          type: 'pie'
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480
          }
        ]
      }
      this.seriesUsage = []
      this.chartCreated = {
        colors: [],
        chart: {
          width: 380,
          type: 'pie'
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480
          }
        ]
      }
      this.seriesCreated = []
      await axios.post('https://gcs0lrdh38.execute-api.ap-southeast-1.amazonaws.com/prod/getCouponUsageReport', payload).then(res => {
        if (res.status === 200) {
          this.tableData = res.data
          this.createdData = res.data.created
          this.usageData = res.data.usage
          this.createdData.map(ccp => {
            if (ccp.coupon_amount !== null) {
              this.chartCreated.labels.push(ccp.title_mon)
              this.seriesCreated.push(parseFloat(ccp.coupon_amount))
            }
          })
          this.usageData.map(ucp => {
            if (ucp.coupon_amount !== null) {
              this.chartUsage.labels.push(ucp.title_mon)
              this.seriesUsage.push(parseFloat(ucp.coupon_amount))
            }
          })
        } else {
          this.$message.error('Алдаа, нийт жагсаалт татахад алдаа гарлаа.')
        }
        this.loading = false
      })
    },
    excelDownload (type) {
      this.excelLoading = true
      let reportXlsx
      if (this.createdData.length > 0 || this.usageData.length > 0) {
        if (type === 'created' && this.createdData.length > 0) {
          reportXlsx = XLSX.utils.json_to_sheet(this.createdData)
        } else if (type === 'usage' && this.usageData.length > 0) {
          this.usageData.forEach(el => {
            delete el.total_created
            delete el.total_created_amount
          })
          reportXlsx = XLSX.utils.json_to_sheet(this.usageData)
        }
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, reportXlsx, 'settlementList')
        const currentdate = new Date()
        const datetime =
          currentdate.getFullYear() +
          '_' +
          currentdate.getDate() +
          '_' +
          (currentdate.getMonth() + 1) +
          ' ' +
          currentdate.getHours() +
          '_' +
          currentdate.getMinutes() +
          '_' +
          currentdate.getSeconds()
        XLSX.writeFile(wb, 'settlementList' + datetime + '.xlsx')
        this.excelLoading = false
      } else {
        this.excelLoading = false
      }
    }
  }
}
</script>
<style scoped>
.chartContainer {
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  margin-right: 2%;
  flex-wrap: wrap;
  margin-top: 1%;
  margin-bottom: 1%;
  width: 100%;
  height: 100%;
}
</style>
